import { Component } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { LanguageService } from '../language.service';
import { TranslationService } from '../translation.service';

@Component({
  selector: 'app-story',
  standalone: true,
  imports: [HeaderComponent, CommonModule],
  templateUrl: './story.component.html',
  styleUrl: './story.component.css'
})
export class StoryComponent {
  // UI state
  libraryMessage = '';
  isLoading = true;
  errorMessage = '';
  showBalanceAlert = false;
  balanceAlertMessage = '';
  balanceAlertType: 'success' | 'error' | 'warning' = 'error';

  // Story + chapters
  storyId: number | null = null;
  storyDetail: any = null;
  stories: any[] = [];
canShowFollowBtn = false;
  // Author / follow
  isFollowing = false;
  followerUsers: any[] = [];
  followerCount = 0;

  userId: number | null = null;
  
  likedStories: number[] = [];
  libraryStories: any[] = [];   
  paymentProcessing: boolean = false;
  userReaderBalance: number = 0;
  isBalanceLoaded = false;
 
  starArray: string[] = [];
  
  authorProfileUrl = '';
  authorCoverUrl = '';
  authorInitial = 'U';
  hideAuthorImage = false;
  selectedLanguage: string = 'en';
  defaultProfileImage = 'default-profile.png';
  showBalancePopup: boolean = false;
  popupData: any = {
    episodePrice: 0,
    currentBalance: 0,
    shortfall: 0
  };

  // Base API path
  storyImgPath = 'https://stories.funtelstudio.com/storyapi/';

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    public translationService: TranslationService,
    private languageService: LanguageService 
  ) {}

  async ngOnInit(): Promise<void> {
    this.selectedLanguage = this.languageService.getCurrentLanguage();
    
    this.languageService.currentLanguage$.subscribe(lang => {
      this.selectedLanguage = lang;
    });
    
    window.scrollTo(0, 0);

    // ✅ Wait for user to load first
    this.authService.currentUser$.subscribe(user => {
      if (user?.id) {
        this.userId = +user.id;
        this.updateFollowButtonVisibility();
        console.log('✅ User loaded:', this.userId);
        
        // Load wallet balance after user is available
        this.loadUserWalletBalance().then(() => {
          console.log('✅ Wallet balance loaded in ngOnInit:', this.userReaderBalance);
        });
      } else {
        console.log('⚠️ User not logged in');
      }
    });

    this.route.paramMap.subscribe(async params => {
      const param = params.get('idAndTitle');
      if (!param) return;

      const id = param.split('-')[0];
      this.storyId = Number(id);
      console.log('✅ Story ID loaded:', this.storyId);

      await this.fetchStoryDetail();
      this.fetchStories();
      await this.loadLibrary();
      this.applyAuthorAssetsFromLibrary();
      this.getFollowingUsers();
      
      this.isLoading = false;
    });
  }
getCategoryName(): string {
  if (!this.storyDetail?.category) {
    return 'Unknown Category';
  }
  
  // Check different possible category property names
  return this.storyDetail.category.categoryName || 
         this.storyDetail.category.name || 
         this.storyDetail.category_name || 
         'Unknown Category';
}
get canShowFollowButton(): boolean {
  return !!(
    this.userId &&
    this.storyDetail?.author_id &&
    this.storyDetail.author_id !== this.userId
  );
}
getCategoryId(): string {
  if (!this.storyDetail?.category) {
    return '';
  }
  
  return this.storyDetail.category.id || 
         this.storyDetail.category.categoryId || 
         this.storyDetail.category_id || 
         '';
}
goToCategory(): void {
  const categoryName = this.getCategoryName();
  const categoryId = this.getCategoryId();
  
  if (!categoryId) {
    console.warn('❌ Category ID not available');
    return;
  }
  
  const slug = this.slugify(categoryName);
  this.router.navigate(['/category', categoryId, slug]);
}

  t(key: string): string {
    return this.translationService.translate(key);
  }

  // ✅ UPDATED: Load user wallet balance
loadUserWalletBalance(): Promise<number> {
  return new Promise((resolve, reject) => {
    const userId = this.authService.getCurrentUserId();
    if (!userId) {
      console.log('❌ User not logged in for wallet balance');
      this.userReaderBalance = 0;
      this.isBalanceLoaded = true;
      resolve(0);
      return;
    }

    console.log('🔄 Loading wallet balance for user:', userId);
    
    this.http.get<any>(`${this.storyImgPath}get_wallet_data.php?type=reader`, {
      withCredentials: true
    }).subscribe({
      next: (response) => {
        console.log('💰 Wallet API response:', response);
        
        if (response.status === 'success' && response.reader_wallet) {
          // Aapke structure me reader_wallet.balance already available recharge amount hai
          this.userReaderBalance = response.reader_wallet.balance || 0;
          this.isBalanceLoaded = true;
          console.log('✅ User reader balance loaded:', this.userReaderBalance);
          resolve(this.userReaderBalance);
        } else {
          console.error('❌ Wallet API response error:', response);
          this.userReaderBalance = 0;
          this.isBalanceLoaded = true;
          resolve(0);
        }
      },
      error: (error) => {
        console.error('❌ Error loading wallet balance:', error);
        this.userReaderBalance = 0;
        this.isBalanceLoaded = true;
        resolve(0);
      }
    });
  });
}

  // ✅ UPDATED: Episode click handler with payment processing
  async handleChapterClick(index: number, story: any): Promise<void> {
    // Check if user needs to login for chapters beyond first one
    if (index >= 1 && !this.userId) {
      this.router.navigate(['/login']);
      return;
    }
    
    if (story.monetization_enabled && story.monetization_amount > 0) {
     
     
      try {
        const currentBalance = await this.loadUserWalletBalance();
       
        
        if (currentBalance >= story.monetization_amount) {
          await this.processEpisodePayment(story);
        } else {
          this.showInsufficientBalanceAlert(story.monetization_amount, currentBalance);
        }
      } catch (error) {
        console.error('❌ Balance load failed:', error);
        alert('Failed to check wallet balance. Please try again.');
      }
    } else {
      // Free episode, proceed directly
      console.log('🆓 Free episode - Proceeding directly');
      this.goToSeries(story);
    }
  }

  // ✅ NEW: Process episode payment
  async processEpisodePayment(story: any): Promise<void> {
    if (this.paymentProcessing) {
      console.log('❌ Payment already in progress');
      return;
    }

    this.paymentProcessing = true;
    console.log('🚀 Starting payment processing for episode:', story.id);

    const userId = this.authService.getCurrentUserId();
    if (!userId) {
      this.router.navigate(['/login']);
      return;
    }

    const paymentData = {
      user_id: userId,
      content_id: story.id,
      amount: story.monetization_amount
    };

    console.log('📤 Sending payment request:', paymentData);

    try {
      const response = await this.http.post<any>(
        `${this.storyImgPath}deduct_episode_payment.php`,
        paymentData,
        { withCredentials: true }
      ).toPromise();

      console.log('✅ Payment API Response:', response);

      if (response.status === 'success') {
        // Update local balance
        this.userReaderBalance = response.new_balance;
        console.log('💰 Balance updated to:', this.userReaderBalance);
        
        // Show success message
        this.showPaymentSuccess(story.monetization_amount, response.new_balance);
        
        // Navigate to the episode
        this.goToSeries(story);
      } else {
        console.error('❌ Payment failed:', response.message);
        alert('Payment failed: ' + response.message);
      }
    } catch (error: any) {
      console.error('❌ Payment API Error:', error);
      alert('Payment processing failed: ' + (error.error?.message || error.message));
    } finally {
      this.paymentProcessing = false;
    }
  }

  // ✅ NEW: Show insufficient balance alert
  showInsufficientBalanceAlert(episodePrice: number, currentBalance: number): void {
    const shortfall = episodePrice - currentBalance;
    
    this.popupData = {
      episodePrice: episodePrice,
      currentBalance: currentBalance,
      shortfall: shortfall
    };
    
    this.showBalancePopup = true;
    console.log('💰 Insufficient balance popup shown:', this.popupData);
  }

  // ✅ NEW: Close popup
  closeBalancePopup(): void {
    this.showBalancePopup = false;
    this.popupData = {
      episodePrice: 0,
      currentBalance: 0,
      shortfall: 0
    };
  }
navigateToWallet(): void {
    this.closeBalancePopup();
    this.router.navigate(['/wallet']);
  }

  // ✅ NEW: Continue reading (if user wants to read free content)
  continueReading(): void {
    this.closeBalancePopup();
    // Optional: You can add logic for free content access here
  }
  // ✅ NEW: Show payment success
  showPaymentSuccess(amount: number, newBalance: number): void {
    console.log(`✅ Payment successful! ₹${amount} deducted. New balance: ₹${newBalance}`);
    // You can show a toast notification here instead of alert
    // alert(`Payment successful! ₹${amount} deducted from your wallet.`);
  }

  // Rest of the existing methods remain the same...
  private normPath(p: string | null | undefined): string {
    return p ? p.replace(/^\/+/, '') : '';
  }

  private fullAsset(rel?: string | null): string {
    if (!rel || rel.trim() === '' || rel === 'null') {
      return '';
    }
    const path = rel.replace(/^\/+/, '');
    return `${this.storyImgPath}${path}`;
  }

  scrollToChapters(): void {
    const el = document.getElementById('chapters');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }

  viewProfile(authorId: string) {
    this.router.navigate(['/profile', authorId]);
  }
  

  fetchStoryDetail(): Promise<void> {
  return new Promise((resolve) => {
    if (!this.storyId) return resolve();

    const headers = new HttpHeaders({
      'content-type': 'application/json',
    });

    this.http.post<{ status: string; data: any }>(
      `${this.storyImgPath}getstorydetails.php?id=${this.storyId}`,
      {},
      { headers }
    ).subscribe({
      next: (response) => {
        if (response.status === 'success' && response.data) {
          this.storyDetail = response.data;
          this.storyDetail.author_id = this.storyDetail.user_id;

          // ✅ IMPROVED: Ensure category data exists
          if (!this.storyDetail.category) {
            console.warn('⚠️ Category data missing, creating default');
            this.storyDetail.category = {
              categoryName: this.storyDetail.genre || 'General',
              id: this.storyDetail.category_id || '1'
            };
          }

          const rating = +this.storyDetail.average_rating || 0;
          this.starArray = this.getStarArray(rating);

          this.buildAuthorAssetsFromDetail();
          this.checkFollowStatus();
          this.updateFollowButtonVisibility(); 
          resolve();
        } else {
          this.errorMessage = 'Story detail not found.';
          resolve();
        }
      },
      error: (error) => {
        console.error('❌ Error fetching story detail:', error);
        this.errorMessage = 'Failed to load story detail.';
        resolve();
      }
    });
  });
  }

  private updateFollowButtonVisibility(): void {
  if (!this.userId || !this.storyDetail?.author_id) {
    this.canShowFollowBtn = false;
    return;
  }

  // ❌ apna khud ka profile
  if (+this.storyDetail.author_id === +this.userId) {
    this.canShowFollowBtn = false;
  } else {
    // ✅ dusre user ka profile
    this.canShowFollowBtn = true;
  }
}

  private buildAuthorAssetsFromDetail(): void {
    if (!this.storyDetail) {
      this.authorProfileUrl = '';
      this.authorInitial = 'U';
      this.hideAuthorImage = true;
      return;
    }

    this.hideAuthorImage = false;

    const name = this.storyDetail.author_name || (this.storyDetail as any).name || '';
    this.authorInitial = name ? name.trim().charAt(0).toUpperCase() : 'U';

    const profRaw = this.storyDetail.profileimg_url ?? 
                   this.storyDetail.profileImg ?? 
                   this.storyDetail.profileimg ?? 
                   this.storyDetail.author_profile ??
                   '';

    this.authorProfileUrl = this.fullAsset(profRaw);
  }

  fetchStories(): void {
    if (!this.storyId) return;

    const headers = new HttpHeaders({
      'content-type': 'application/json',
    });

    this.http.post<{ status: string; data: any[] }>(
      `${this.storyImgPath}get_user_ep.php?stories_id=${this.storyId}`,
      { headers }
    ).subscribe({
      next: (response) => {
        if (response.status === 'success' && response.data) {
          this.stories = response.data.map(story => {
            const content = story.content || '';
            const wordCount = content.split(/\s+/).length;
            const readTime = Math.ceil(wordCount / 200);
            
            const monetization_enabled = story.monetization_enabled || 0;
            const monetization_amount = story.monetization_amount || 0;
            
            return { 
              ...story, 
              wordCount, 
              readTime,
              monetization_enabled: parseInt(monetization_enabled),
              monetization_amount: parseFloat(monetization_amount)
            };
          });
          
          console.log('📖 Stories loaded:', this.stories.length);
        } else {
          this.errorMessage = 'Story not found.';
        }
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error fetching story:', error);
        this.errorMessage = 'Failed to load story.';
        this.isLoading = false;
      }
    });
  }

  loadLibrary(): Promise<void> {
    return new Promise((resolve, reject) => {
      const userId = this.authService.getCurrentUserId();
      if (!userId) return resolve();

      const headers = new HttpHeaders({
        'content-type': 'application/json',
      });

      this.http.get<any>(`${this.storyImgPath}allstory.php?action=library&user_id=${userId}`,
        { headers: headers, withCredentials: true }
      ).subscribe({
        next: (res) => {
          if (res.status === 'success') {
            this.libraryStories = res.data || [];
            this.likedStories = this.libraryStories.map((s: any) => +s.id);
            this.applyAuthorAssetsFromLibrary();
          }
          resolve();
        },
        error: (err) => {
          console.error('Failed to load library:', err);
          reject(err);
        }
      });
    });
  }

  private applyAuthorAssetsFromLibrary(): void {
    if (!this.storyId || !this.libraryStories?.length) return;

    const rec = this.libraryStories.find(s => 
      +s.id === this.storyId || +s.story_id === this.storyId
    );

    if (!rec) return;

    const authorName = rec.author_name || rec.name || '';
    const authorImg = rec.profileImg;
    this.authorInitial = authorName.trim().charAt(0).toUpperCase() || 'U';
    this.authorProfileUrl = this.fullAsset(authorImg);
    
    const profileRaw = rec.profileImg || rec.profileimg || rec.profileimg_url || '';
    const profileUrl = this.fullAsset(profileRaw);

    if (profileUrl && !profileUrl.includes('null') && !profileUrl.endsWith('/')) {
      this.authorProfileUrl = profileUrl;
    } else {
      this.authorProfileUrl = this.defaultProfileImage;
    }

    const coverRaw = rec.coverImg || rec.coverimg || rec.coverimage_url || '';
    this.authorCoverUrl = this.fullAsset(coverRaw);
  }

  getFollowingUsers(): void {
    if (!this.storyDetail?.author_id) return;

    const body: any = { following_id: this.storyDetail.author_id };
    if (this.userId) body.follower_id = this.userId;

    const headers = new HttpHeaders({ 'content-type': 'application/json' });

    this.http.post<any>(
      `${this.storyImgPath}follow/check_follow.php`,
      body,
      { headers, withCredentials: true }
    ).subscribe({
      next: (res) => {
        this.followerUsers = res.followersList || [];
        this.followerCount = res.followerCount || 0;

        if (typeof res.isFollowing !== 'undefined') {
          this.isFollowing = !!res.isFollowing;
        }
      },
      error: (err) => {
        console.error('Failed to load followers', err);
      }
    });
  }

  checkFollowStatus(): void {
  const authorId = this.storyDetail?.author_id;

  // 🔒 Self follow check
  if (!this.userId || !authorId || this.userId === +authorId) {
    this.isFollowing = false;
    return;
  }

  this.http.post<any>(
    `${this.storyImgPath}follow/check_follow.php`,
    { follower_id: this.userId, following_id: authorId },
    { withCredentials: true }
  ).subscribe({
    next: (res) => {
      this.isFollowing = !!res.isFollowing;
    }
  });
}

  toggleFollow(): void {
  const authorId = +this.storyDetail?.author_id;
  const uid = this.userId;

  // 🔒 Not logged in
  if (!uid) {
    this.router.navigate(['login']);
    return;
  }

  // 🔒 SELF FOLLOW BLOCK
  if (uid === authorId) {
    console.warn('❌ Self-follow not allowed');
    return;
  }

  const apiUrl = this.isFollowing
    ? `${this.storyImgPath}follow/unfollow.php`
    : `${this.storyImgPath}follow/follow.php`;

  const headers = new HttpHeaders({
    'content-type': 'application/json',
  });

  const body = {
    follower_id: uid,
    following_id: authorId
  };

  this.http.post<any>(apiUrl, body, { headers, withCredentials: true })
    .subscribe({
      next: () => {
        this.isFollowing = !this.isFollowing;
        this.getFollowingUsers();
      },
      error: (err) => {
        console.error('Follow/Unfollow failed:', err);
      }
    });
}

  addToLibrary(storyId: number): void {
    const userId = this.authService.getCurrentUserId();
    if (!userId) {
      this.router.navigate(['login']);
      return;
    }

    const alreadyLiked = this.likedStories.includes(storyId);
    const body = {
      user_id: userId,
      story_id: storyId,
      like_story: !alreadyLiked
    };
    
    const headers = new HttpHeaders({
      'content-type': 'application/json',
    });
    
    this.http.post<any>(`${this.storyImgPath}addstory.php`, body,{
      headers,
      withCredentials: true
    }).subscribe({
      next: (res) => {
        if (res.status === 'success') {
          if (!alreadyLiked) {
            this.likedStories.push(storyId);
            this.libraryMessage = 'Story added to library';
          } else {
            this.likedStories = this.likedStories.filter(id => id !== storyId);
            this.libraryMessage = 'Story removed from library';
          }
        } else if (res.status === 'removed') {
          this.likedStories = this.likedStories.filter(id => id !== storyId);
          this.libraryMessage = 'Story removed from library';
        } else {
          this.libraryMessage = res.message || 'Unexpected response';
        }
        setTimeout(() => this.libraryMessage = '', 3000);
      },
      error: () => {
        console.error('Library action failed');
      }
    });
  }

  getStarArray(rating: number): string[] {
    const stars: string[] = [];
    const fullStars = Math.floor(rating);
    const frac = rating - fullStars;
    const hasHalfStar = frac >= 0.25 && frac < 0.75;

    for (let i = 0; i < fullStars; i++) stars.push('full');
    if (hasHalfStar) stars.push('half');
    while (stars.length < 5) stars.push('empty');
    return stars;
  }

  getTotalReadingTime(): number {
    return this.stories.reduce((sum, s) => sum + (s.readTime || 0), 0);
  }

  formatTotalReadTime(minutes: number): string {
    if (minutes >= 10080) {
      const weeks = Math.floor(minutes / 10080);
      const rem = minutes % 10080;
      return `${weeks} week${weeks > 1 ? 's' : ''}` + (rem ? ` ${this.formatTotalReadTime(rem)}` : '');
    } else if (minutes >= 1440) {
      const days = Math.floor(minutes / 1440);
      const rem = minutes % 1440;
      return `${days} day${days > 1 ? 's' : ''}` + (rem ? ` ${this.formatTotalReadTime(rem)}` : '');
    } else if (minutes >= 60) {
      const hrs = Math.floor(minutes / 60);
      const rem = minutes % 60;
      return `${hrs} hr${hrs > 1 ? 's' : ''}` + (rem ? ` ${rem} min` : '');
    } else {
      return `${minutes} min`;
    }
  }

  getTotalViews(): number {
    return this.stories.reduce((sum, s) => sum + (+s.views || 0), 0);
  }

  formatCount(num: number): string {
    if (num >= 1_000_000) return (num / 1_000_000).toFixed(1) + 'M';
    if (num >= 1_000) return (num / 1_000).toFixed(1) + 'K';
    return num.toString();
  }

  slugify(text: string): string {
    return text.toLowerCase().trim()
      .replace(/[\s\W-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  goToEdit(story: any): void {
    const slug = this.slugify(story.story_title);
    const partId = story.id;
    this.router.navigate(['/story-write', `${partId}-${slug}`]);
  }

  goToCreate(): void {
    if (!this.stories.length) return;
    const storyId = this.stories[0].stories_id;
    this.router.navigate(['/creat', storyId]);
  }

  goToSeries(story: any): void {
    this.incrementView(story.id).then(() => {
      const id = story.id;
      const slug = this.slugify(story.story_title || '');
      this.router.navigate(['/series', `${id}-${slug}`]);
    });
  }

  incrementView(contentId: number): Promise<void> {
    const headers = new HttpHeaders({
      'content-type': 'application/json',
    });
    return new Promise((resolve, reject) => {
      this.http.post(
        `${this.storyImgPath}increment_view.php`,
        { content_id: contentId },
        { headers }
      ).subscribe({
        next: () => resolve(),
        error: err => {
          console.error('Failed to increment view count', err);
          reject();
        }
      });
    });
  }

  onImageError(): void {
    this.hideAuthorImage = true;
  }
  
  getTimeAgo(dateString: string): string {
    if (!dateString) return '';

    const parsedDate = new Date(dateString.replace(' ', 'T'));

    if (isNaN(parsedDate.getTime())) return 'Invalid date';

    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - parsedDate.getTime()) / 1000);

    if (diffInSeconds < 0) return 'Just now';

    const intervals = [
      { label: 'year', seconds: 31536000 },
      { label: 'month', seconds: 2592000 },
      { label: 'week', seconds: 604800 },
      { label: 'day', seconds: 86400 },
      { label: 'hour', seconds: 3600 },
      { label: 'minute', seconds: 60 },
      { label: 'second', seconds: 1 }
    ];

    for (const interval of intervals) {
      const count = Math.floor(diffInSeconds / interval.seconds);
      if (count >= 1) {
        return `${count} ${interval.label}${count > 1 ? 's' : ''} ago`;
      }
    }

    return 'Just now';
  }
  
  getValidDate(story: any): string {
    return story.updated_at || story.updated || story.updated_at || story.author_created_at || '';
  }
}